export default __webpack_public_path__ + "static/ahmad bilal-cca84adf8d80dbe8a0585755a0541ad9.jpg";